
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {ProfilePayload} from '../models/ProfilePayload'
import {ProfileModel} from '../models/ProfileModel'

export class ProfileController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/profile');
    }
    
        get(owner:ISupportSpinner, success:{(res:ProfilePayload):any}, error?:AjaxError) {
    super._call('get', '', owner, null, null, success, error)
}

        submitRequest(owner:ISupportSpinner, model:ProfileModel, success:{():any}, error?:AjaxError) {
    super._call('post', '', owner, null, model, success, error, 'text')
}

        updateContact(owner:ISupportSpinner, model:ProfileModel, success:{():any}, error?:AjaxError) {
    super._call('put', 'update', owner, null, model, success, error, 'text')
}

        cancelRequest(owner:ISupportSpinner, success:{():any}, error?:AjaxError) {
    super._call('delete', '', owner, null, null, success, error, 'text')
}
}
